import React from 'react';
import {SearchMobile} from '../search/SearchMobile';
import {JobSearchProps} from '../search/SearchStandard';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid/Grid';

interface Props {
    setOpenedFilterBarMobile: (arg1: boolean) => void;
    filterLabel?: string;
    mobileSearchLabel?: string;
    searchLabel?: string;
}

const Styled = styled.div`
    background-color: #202024;
    color: #e6e6ea;
    display: inline-block;
    cursor: pointer;
    width: 100%;

    text-align: center;
    width: 100%;

    .toggleCheckboxFilterButton {
        border-right: 1px solid #303034;
    }

    .toggleCheckboxFilterButton,
    .toggleSearchButton {
        width: 100%;
        height: 100%;
        display: inline-flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: center;
        padding: 10px 20px 10px 20px;
        text-align: center;
        svg {
            padding-right: 6px;
            font-size: 22px;
            path {
                fill: #aaaaae;
            }
        }
    }

    .toggleSearchButton {
        padding-left: 25%;
        input {
            color: #e6e6ea;
            background-color: #202024;
            caret-color: #fff;
            outline: none;
            width: 50%;
            border: 0px;
            font-size: 16px;
            padding: 6px 10px;
            width: 80%;
            &::placeholder {
                color: #e6e6ea;
            }
            &:focus::placeholder {
                color: #757575;
            }
        }
    }

    ${(p) => p.theme.breakpoints.down('sm')} {
        .filters-bar,
        .filters-search-bar {
            display: none;
        }
        .filters-bar.opened-mobile,
        .filters-search-bar.opened-mobile {
            display: block;
        }

        display: block;
        padding: 6xp 10px;
        font-size: 16px;

        svg {
            cursor: pointer;
        }
    }
`;

export const MobileFilters = ({
    setOpenedFilterBarMobile,
    search,
    setSearch,
    setJobResultsPage,
    filterLabel,
    mobileSearchLabel
}: Props & JobSearchProps): JSX.Element => {
    return (
        <Styled className="toggleFiltersSection">
            <Grid container direction="row">
                <Grid item xs={6} sm={6}>
                    <div
                        className="toggleCheckboxFilterButton"
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                            setOpenedFilterBarMobile(true);
                        }}>
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4.75 2.75C4.75 2.33579 4.41421 2 4 2C3.58579 2 3.25 2.33579 3.25 2.75V10H3C2.44772 10 2 10.4477 2 11C2 11.5523 2.44772 12 3 12H3.25V17.25C3.25 17.6642 3.58579 18 4 18C4.41421 18 4.75 17.6642 4.75 17.25V12H5C5.55228 12 6 11.5523 6 11C6 10.4477 5.55228 10 5 10H4.75V2.75ZM10.75 2.75C10.75 2.33579 10.4142 2 10 2C9.58579 2 9.25 2.33579 9.25 2.75V5H9C8.44772 5 8 5.44772 8 6C8 6.55228 8.44772 7 9 7H9.25V17.25C9.25 17.6642 9.58579 18 10 18C10.4142 18 10.75 17.6642 10.75 17.25V7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H10.75V2.75ZM16 2C16.4142 2 16.75 2.33579 16.75 2.75V13H17C17.5523 13 18 13.4477 18 14C18 14.5523 17.5523 15 17 15H16.75V17.25C16.75 17.6642 16.4142 18 16 18C15.5858 18 15.25 17.6642 15.25 17.25V15H15C14.4477 15 14 14.5523 14 14C14 13.4477 14.4477 13 15 13H15.25V2.75C15.25 2.33579 15.5858 2 16 2Z"
                                fill="black"
                            />
                        </svg>{' '}
                        {filterLabel || 'Filter'}
                    </div>
                </Grid>
                <Grid item xs={6} sm={6}>
                    <SearchMobile
                        search={search}
                        setSearch={setSearch}
                        setJobResultsPage={setJobResultsPage}
                        searchLabel={mobileSearchLabel || 'Search'}
                    />
                </Grid>
            </Grid>
        </Styled>
    );
};
